import { CmsApiPagePage } from 'modules/cms/api/types/CmsApiPage';
import { CmsAmpPageOrPostBodyLoadable } from 'modules/cms/components/AmpPageOrPostBody/CmsAmpPageOrPostBodyLoadable';
import { CmsContentPageHooksAndClickContainer } from 'modules/cms/containers/CmsContentPageHooksAndClickContainer';
import { useAmpContext } from 'utils/AmpContext';

import { CmsPagePageBody } from './CmsPagePageBody';
import { CmsPagePageLayout } from './CmsPagePageLayout';

type Props = {
  content: CmsApiPagePage;
};

export function CmsPagePage({ content }: Props) {
  const requestIsAmp = useAmpContext();

  if (requestIsAmp) {
    return (
      <CmsPagePageLayout content={content}>
        <CmsAmpPageOrPostBodyLoadable content={content} />
      </CmsPagePageLayout>
    );
  }

  return (
    <CmsPagePageLayout content={content}>
      <CmsContentPageHooksAndClickContainer content={content}>
        <CmsPagePageBody content={content} />
      </CmsContentPageHooksAndClickContainer>
    </CmsPagePageLayout>
  );
}
